/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { deviceTypeEnumSchema } from "./deviceTypeEnumSchema.ts";
import { orderTypeSchema } from "./orderTypeSchema.ts";
import { paymentProviderTypeSchema } from "./paymentProviderTypeSchema.ts";
import { scheduleSchema } from "./scheduleSchema.ts";

export const deviceInfoSchema = z
	.object({
		id: z.uuid(),
		name: z.string().max(100),
		device_type: deviceTypeEnumSchema.describe("* `kiosk` - Киоск\n* `planshet-kiosk` - Планшет-киоск"),
		order_types: z.array(orderTypeSchema),
		payment_provider_type: z.array(paymentProviderTypeSchema),
		last_revision_hot_menu_update_at: z.iso.datetime(),
		is_ok: z
			.boolean()
			.optional()
			.describe("Это значение невозможно выставить вручную, оно проставляется автоматически на основе данных из Device Health Check."),
		auto_fiscal_and_pay: z.boolean().optional().describe("Ускоренный режим фискализации и активации терминала. Не поддерживает режим фейковой фискализации"),
		marking_gs_substitute: z
			.string()
			.max(10)
			.optional()
			.describe(
				"Сканер в режиме клавиатуры не передаёт невидимый разделитель GS, и киоск пишет «отсутствует разделитель». Укажите символ, который сканер присылает вместо GS (настраивается в самом сканере), и киоск заменит его на GS при разборе кода. Если поле пусто, то замены нет.",
			),
		schedule: scheduleSchema,
	})
	.describe("Сериализатор вывода инфо об устройстве.");
